module.exports = __webpack_public_path__ + "static/media/097.d121991e.jpg";